// src/features/hira/herbalPendingSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { fetchHerbalPendingCount } from "@core/api/encounterHerbalApi"

interface HerbalPendingState {
  pendingCount: number
  loading: boolean
  error: string | null
}

const initialState: HerbalPendingState = {
  pendingCount: 0,
  loading: false,
  error: null,
}

const herbalPendingSlice = createSlice({
  name: "herbalPending",
  initialState,
  reducers: {
    setHerbalPendingCount(state, action: PayloadAction<number>) {
      state.pendingCount = action.payload
      state.error = null
    },
    incrementHerbalPendingCount(state) {
      state.pendingCount += 1
    },
    decrementHerbalPendingCount(state) {
      if (state.pendingCount > 0) {
        state.pendingCount -= 1
      }
    },
    setHerbalPendingLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setHerbalPendingError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
    resetHerbalPendingCount(state) {
      state.pendingCount = 0
      state.loading = false
      state.error = null
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchHerbalPendingCount.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchHerbalPendingCount.fulfilled, (state, action) => {
        state.loading = false
        state.pendingCount = action.payload
        state.error = null
      })
      .addCase(fetchHerbalPendingCount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "자보첩약 미제출 건수 조회에 실패했습니다."
      })
  },
})

export const {
  setHerbalPendingCount,
  incrementHerbalPendingCount,
  decrementHerbalPendingCount,
  setHerbalPendingLoading,
  setHerbalPendingError,
  resetHerbalPendingCount,
} = herbalPendingSlice.actions

export default herbalPendingSlice.reducer
